/*!
 * @king-design v3.4.3
 *
 * Copyright (c) Kingsoft Cloud
 * Released under the MIT License
 *
 * Documentation available at
 * https://ksc-fe.github.io/kpc/
 */
export { _$, localize } from './i18n';
export { bind } from './components/utils';
export { setTheme, theme } from './styles/theme';
/* generate start */
export * from './components/affix';
export * from './components/badge';
export * from './components/breadcrumb';
export * from './components/button';
export * from './components/card';
export * from './components/carousel';
export * from './components/cascader';
export * from './components/checkbox';
export * from './components/collapse';
export * from './components/colorpicker';
export * from './components/config';
export * from './components/copy';
export * from './components/datepicker';
export * from './components/descriptions';
export * from './components/dialog';
export * from './components/divider';
export * from './components/drawer';
export * from './components/dropdown';
export * from './components/editable';
export * from './components/ellipsis';
export * from './components/form';
export * from './components/grid';
export * from './components/icon';
export * from './components/input';
export * from './components/layout';
export * from './components/menu';
export * from './components/message';
export * from './components/pagination';
export * from './components/popover';
export * from './components/progress';
export * from './components/radio';
export * from './components/rate';
export * from './components/scrollSelect';
export * from './components/select';
export * from './components/skeleton';
export * from './components/slider';
export * from './components/spin';
export * from './components/spinner';
export * from './components/split';
export * from './components/steps';
export * from './components/switch';
export * from './components/table';
export * from './components/tabs';
export * from './components/tag';
export * from './components/timeline';
export * from './components/timepicker';
export * from './components/tip';
export * from './components/tooltip';
export * from './components/transfer';
export * from './components/tree';
export * from './components/treeSelect';
export * from './components/upload';
export * from './components/view';
export * from './components/wave';
export var version = '3.4.3';
/* generate end */

export {normalize} from 'intact-vue-next';